import { modalWindows as EnUsModalWindows } from '../en-us/modalWindows';
import { AgResourceLanguage } from '../types';

export const modalWindows: AgResourceLanguage['modalWindows'] = {
  ...EnUsModalWindows,
  editShippingMethod: {
    titleHeader: 'Redigera Leveransmetod',
    subtitle: 'Välj:',
    saveMethodButton: 'Spara Leveransmetod'
  },
  editShippingAddress: {
    bannerText: 'Leveransadressen kommer att ändras från och med nästa leverans',
    titleHeaderCreate: 'Skapa leveransadress',
    subscriptionUpdate: 'Ange som leveransadress för mitt abonnemang',
    address2: 'Lägenhet, Suite, Etc. (valfritt)',
    city: 'Stad',
    usedSavedLabel: 'Använd sparad adress',
    zip: 'Postnummer',
    titleAddress: 'Redigera Adress',
    titleHeaderEdit: 'Redigera leveransadress',
    last_name: 'Efternamn',
    company: 'Företag (valfritt)',
    first_name: 'Förnamn',
    phone: 'Telefon',
    province: 'Stat',
    deleteAddressText: 'Är du säker på att du vill radera sparad adress?',
    selectAddress: {
      reloadMessage: 'Ladda om sidan, tack',
      noSavedAddressText: 'Du har inga sparade adresser just nu',
      useSavedAddressButton: 'Använd sparad adress',
      noSavedAddressButton: 'Inga sparade adresser',
      titleForSelectAddressModal: 'Välj Leveransadress',
      cancelButton: 'Avbryt',
      submitButton: 'Ok',
      useSelectButton: 'Använd vald'
    },
    massUpdate: 'Använd för alla aktiva abonnemang',
    deleteAddressTitle: 'Radera adress',
    updateButton: 'Uppdatera',
    address1: 'Adress',
    country: 'Land',
    cancelButton: 'Avbryt'
  },
  addPaymentMethod: {
    title: 'Lägg till Betalningsmetod',
    instructions:
      'Ett e-postmeddelande kommer att skickas till {{email}} för att säkert lägga till din betalningsmetod. Bekräfta nedan för att skicka e-post.'
  },
  editPaymentMethod: {
    title: 'Redigera Betalningsmetod',
    instructions:
      'Ett e-postmeddelande kommer att skickas till {{email}} för att säkert redigera din betalningsmetod. Bekräfta nedan för att skicka e-post.',
    shopPayInstructions: `Ett e-postmeddelande kommer att skickas till {{email}} för att säkert ändra din betalningsmetod inom Shop Pay. Bekräfta nedan för att skicka e-postmeddelandet. \n
    Om du vill byta betalningsmetod från Shop Pay till en annan betalningsmetod, som PayPal eller Apple Pay, avbryt din prenumeration genom att återgå till dina prenumerationsuppgifter. När prenumerationen är avbruten, skapa en ny prenumeration och ange den föredragna betalningsmetoden.`
  },
  paymentMethod: {
    cancelButton: 'Avbryt',
    submitButton: 'Skicka E-post',
    successTitle: 'Bekräftelsemail Skickat',
    successMessage: 'Kontrollera din e-post för en bekräftelse'
  },
  cancelSubscription: {
    keepButton: 'Behåll Det',
    commentsPlaceholder: 'Beskriv problemet',
    cancelButton: 'Avsluta Abonnemang',
    reasons:
      'Jag har inte märkt någon fördel,Jag flyttar eller reser,Jag har redan mer än jag behöver,Jag har en medicinsk anledning,Detta är för dyrt,Jag gillar inte smaken,Jag vill inte ha ett abonnemang,Annat skäl',
    v53Reasons: 'Ogillar den nya formeln,Ogillar den nya tropiska smaken',
    agzCancelationReasons:
      'Jag gillar inte smaken av AGZ,Jag har inte märkt några fördelar med AGZ,Jag har redan mer AGZ än jag behöver,Jag vill inte ha en prenumeration,Jag har en medicinsk anledning,Det här är för dyrt,Jag flyttar för att resa,Annan anledning',
    commentsLabel: 'Kommentarer',
    keepSubscriptionButton: 'Behåll Abonnemang',
    text: 'Bekräfta avslutandet av ditt abonnemang nedan. Om du vill lämna en anledning, uppskattar vi din feedback så att vi kan förbättra upplevelsen för andra i framtiden (valfritt):',
    title: 'Vi är ledsna att se dig gå!'
  },
  switchProduct: {
    packName: 'Reseförpackningar',
    modalTitle: 'Byt Till {{productName}}',
    title:
      'Din nästa beställning den {{formatNextOrderDate}} kommer att innehålla {{qtyModal}} låda med {{switchToText}}',
    infoMessage: 'Produkten byts endast för din nästa beställning.',
    cancelButton: 'Avbryt',
    confirmButton: 'Bekräfta',
    pouchName: 'Påsar',
    quantityText: 'Antal {{switchToText}} att byta:',
    description: 'Du kan ändra antalet av din {{switchToText}} på sidan för abonnemangshantering.'
  },
  switchFromFreeShipping: {
    text: 'Ditt nuvarande kostnadsfria fraktplan kräver att du beställer 3 månaders förbrukning av AG1-påsar som skickas var 90:e dag. Genom att byta till reseförpackningar återställs priset till $89 per 30-pack och en fraktkostnad på $9 per order.'
  },
  skipShipment: {
    textConfirm: 'Nästa beställningsdatum ändras till {{date}}',
    skipButton: 'Avbryt',
    questionConfirm: 'Är du säker på att du vill hoppa över nästa leverans?',
    continueButton: 'Fortsätt',
    headConfirm: 'Hoppa över Leverans'
  },
  acceptAddressValidation: {
    title: 'Bekräfta Din Adress',
    continueButton: 'Spara & Fortsätt',
    enteredTitle: 'Angiven Adress',
    editButton: 'Redigera Adress',
    suggestedTitle: 'Föreslagen Adress',
    text: 'Vi kunde inte verifiera den exakta adressen du angav. Se till att den är korrekt eller gör nödvändiga ändringar.'
  },
  shopAlert: {
    deleteButtonTitle: 'Fortsätt',
    cancelButtonTitle: 'Avbryt',
    makeGiftCartButtonTitle: 'Som en Gåva',
    subToGift: {
      headerTitle: 'Innan du lägger till ett abonnemang',
      content:
        'Gåvobeställningar kan endast innehålla produkter som skickas en gång. Om du lägger till ett abonnemang i din varukorg tas gåvoprodukter bort.'
    },
    giftToSub: {
      headerTitle: 'Innan du lägger till en gåva',
      content:
        'Abonnemangsbeställningar kan inte skickas med ett gåvobudskap. Om du lägger till en gåva i din varukorg tas abonnemangsprodukter bort.'
    },
    giftToOtp: {
      headerTitle: 'Gör hela beställningen som en gåva',
      content:
        'Du har redan engångsköpsprodukter i din varukorg. Vill du göra hela beställningen som en gåva?'
    }
  },
  addProductFromSlider: {
    toastNextOrder: 'Produkt tillagd till nästa beställning av ',
    toastSubscription: 'Produkt tillagd till {{name}}',
    toastSeveralSubscription: 'Produkt tillagd till',
    severalSubscriptions: 'abonnemang',
    toastToAllSubscription: 'Produkt tillagd till alla abonnemang',
    toastToAllNextOrder: 'Produkt tillagd till nästa beställning av alla abonnemang',
    titleSubscription: 'Lägg till produkt i Abonnemang',
    titleNextOrder: 'Lägg till produkt i Nästa Beställning',
    checkbox: 'Lägg till i alla aktiva abonnemang',
    text: 'Välj abonnemanget du vill lägga till produkten i.',
    addProductButton: 'Lägg till Produkt'
  },
  cart: {
    subscriptionTitle: 'Abonnemang',
    title: 'Din Varukorg',
    checkoutButtonLabel: 'Till Kassan',
    summary: {
      taxEstimatedLabel: 'Uppskattad Moms',
      taxLabel: 'Moms',
      totalLabel: 'Totalt',
      taxNotReady: '---',
      shippingLabel: 'Frakt',
      discountLabel: 'Din rabatt',
      freePrice: 'Gratis',
      subtotalLabel: 'Delsumma'
    },
    emptyState: {
      oneTimeProductsTitle: 'Medlemmarnas Favoriter',
      addOneTimeProductButton: 'Lägg till i Varukorgen',
      label: 'Lägg till artiklar i din varukorg'
    },
    emptyStateLabel: 'Lägg till artiklar i din varukorg',
    frequencyLabel: 'Skickas var 30:e dag',
    promoCode: {
      promoCTA: 'Har du en kampanjkod?',
      promoError: 'Rabattkoden är ogiltig',
      promoInputLabel: 'Kampanjkod',
      promoButtonLabel: 'Använd'
    }
  },
  changeOrderDate: {
    title: 'Välj Beställningsdatum',
    confirmButton: 'Bekräfta',
    nextOrderDateSuccessText: 'Ditt nästa beställningsdatum blir {{date}}.',
    nextOrderDateChangeText:
      'Ditt nästa beställningsdatum för detta abonnemang kommer att ändras till {{date}} ',
    description: 'Du kan ändra datumet för din nästa beställning',
    newDateChangeText: 'Nästa beställningsdatum är',
    newDateSuccessText: 'Nästa beställningsdatum ändrades till {{date}} '
  },
  shipNow: {
    shipNowButton: 'Bekräfta Beställning',
    subtitle: 'Beställning placerad framgångsrikt',
    description:
      'Denna beställning förväntas skickas inom 24 timmar M-F efter betalning. Vänligen tillåt upp till 48 timmar under helger och helgdagar. Din nästa beställning placeras om {{shipInterval}} på {{date}}',
    title: 'Skicka Nästa Beställning Nu',
    confirm:
      'När du bekräftar nedan kommer din beställning att behandlas inom 1 arbetsdag. Vänligen tillåt upp till 48 timmar under helger och helgdagar.',
    preparing: 'Förbereder',
    preparingDescription: 'Du har en aktuell beställning som väntas skickas',
    shipped: 'Skickad',
    shippedDescription: 'Du har en aktuell beställning som skickats',
    delivered: 'Levererad',
    deliveredDescription: 'Din senaste beställning levererades',
    shipNext: 'Skicka nästa beställning nu:',
    nextOrder: 'Nästa beställning:',
    followedBy: 'Följd av:'
  },
  editFrequency: {
    titleView: 'Redigera Beställningsfrekvens',
    titleDatepicker: 'Ändra Nästa Beställningsdatum',
    day: 'Dag',
    infoMessage: 'Leveransfrekvensen har ändrats till {{date}}.',
    shippingFrequency: 'Leveransfrekvens',
    item: 'Varje',
    nextOrderButton: 'Nästa Beställningsdatum',
    nextOrderLink: 'Ändra nästa beställningsdatum',
    nextOrder: 'Nästa beställning:',
    followedBy: 'Följd av:',
    description: 'Ändringar träder i kraft från och med ditt nästa beställningsdatum.',
    followingText: 'följande',
    ribbonMessage:
      'Denna ändring gäller endast för beställningarna <bold>{{followingText}}</bold> efter ditt nästa beställningsdatum.',
    extraInfo:
      'När du bekräftar nedan debiteras du idag och beställningen skickas inom 1 arbetsdag. Vänligen tillåt upp till 48 timmar under helger och helgdagar.',
    saveButton: 'Spara Ändringar',
    confirmButton: 'Bekräfta'
  },
  acceptChanges: {
    text: 'Uppdatering av dina abonnemangsuppgifter återställer din nästa beställning och tar bort "engångsartiklar".',
    title: 'Innan du Ändrar Ditt Abonnemang',
    continueButton: 'Fortsätt',
    cancelButton: 'Avbryt'
  },
  acceptFreeShippingChanges: {
    text: 'Ditt nuvarande kostnadsfria fraktplan kräver en 3 månaders förbrukning av produkten som skickas var 90:e dag. Genom att ändra kvantiteten återställs priset till $79 per påse och fraktkostnaden till $9 per beställning.',
    title: 'Innan du Ändrar Ditt Abonnemang',
    continueButton: 'Fortsätt',
    cancelButton: 'Avbryt',
    successMessage: 'Ditt abonnemang är nu $79 per påse och medför en fraktkostnad på $9'
  },
  activateSubscription: {
    successTitle: 'Ditt abonnemang {{name}} är aktivt och tillgängligt för hantering.',
    errorMessage: 'Kunde inte ändra beställningsdatum',
    activateButton: 'Aktivera Abonnemang',
    title: 'Återaktivera Abonnemang',
    infoMessage: 'Du kan ändra datumet för din nästa beställning innan ditt abonnemang aktiveras',
    successDescription: 'Nästa beställningsdatum är {{date}}.'
  },
  addProductFromModal: {
    noteTitle: 'How to swap from AG1 Pouch to AG1 30 Ct Travel Packs',
    noteSubtitle:
      'To swap between Pouch and 30 Ct Travel Packs, add the desired product to your subscription by selecting “Add to Subscription”. Once added, remove the other product from your subscription by selecting the trash can icon on your Subscription Details page.',
    addToOrder: 'Lägg till Produkt i Beställning',
    addToSubscription: 'Lägg till i Abonnemang',
    addToNextOrder: 'Lägg till i Nästa Beställning',
    addedToNextOrder: 'Tillagd i Nästa Beställning',
    addedToSubscription: 'Tillagd i Abonnemang'
  }
};
